import { AppState } from 'react-native';

import type { AppStateAdapter, AppStateStatus } from '@/adapters/appState/types';

const mapStatus = (status: string): AppStateStatus => {
  if (status === 'active') {
    return 'active';
  }

  if (status === 'background') {
    return 'background';
  }

  return 'inactive';
};

const appStateAdapter: AppStateAdapter = {
  addEventListener: (callback) => {
    const subscription = AppState.addEventListener('change', (status) => {
      callback(mapStatus(status));
    });

    return () => subscription.remove();
  },
};

export { appStateAdapter };
